export const AWS_EXECUTION_ENV = "AWS_EXECUTION_ENV";
export const AWS_REGION_ENV = "AWS_REGION";
export const AWS_DEFAULT_REGION_ENV = "AWS_DEFAULT_REGION";
export const ENV_IMDS_DISABLED = "AWS_EC2_METADATA_DISABLED";
export const DEFAULTS_MODE_OPTIONS = ["in-region", "cross-region", "mobile", "standard", "legacy"];
export const IMDS_REGION_PATH = "/latest/meta-data/placement/region";
